<template>
    <div class="flex justify-content-between mx-5 my-3">
        <h2 class="text-secondary">Dettagli logs ID: {{ id }}</h2>
        <!-- <Button label="LOG" icon="pi pi-align-left" @click="showLogs()" class="p-button-primary w-1" /> -->
    </div>
    <div>

        <div v-if="loading" class="col-12 h-30rem flex justify-content-center align-items-center">
            <ProgressSpinner style="width: 50px; height: 50px" strokeWidth="8" fill="transparent"
                animationDuration=".5s" aria-label="Custom ProgressSpinner" />
        </div>

        <DataTable v-if="!loading" :value="logs" paginator :rows="100" showGridlines class="file-table">
            <Column field="column_name" header="Nome colonna" style="width: 9%"></Column>
            <Column field="old_value" header="Vecchio valore" style="width: 9%"></Column>
            <Column field="new_value" header="Nuovo valore" style="width: 9%"></Column>
            <Column field="id_record" header="Record ID" style="width: 7%"></Column>
            <Column field="is_new" header="Nuovo" style="width: 6%"></Column>
            <Column field="data" header="Data" style="width: 10%"></Column>
        </DataTable>
    </div>
</template>

<script>
    import { ref, computed, getCurrentInstance, onMounted } from "vue";
    import SyncService from "../../../services/ask-database-sync/database-sync";
    import { useRoute } from 'vue-router';
    import ProgressSpinner from 'primevue/progressspinner';

    export default {
        components: {
            ProgressSpinner
        },
        setup() {
            const logs = ref([]);
            const route = useRoute();
            const id = ref(route.params.id);
            const loading = ref(true);

            const service = new SyncService();

            service.getSyncLogsDetails(id.value).then((data) => {
                logs.value = data;
                loading.value = false;
            });

            return {
                logs,
                id,
                loading
            }
        }
    }
</script>

<style scoped>
</style>